import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { get as _get } from "lodash";

class TechStack extends Component {

  render() {
    const { techStack } = this.props;

    if (!techStack || (techStack || []).length === 0) {
      return (
        <div className="tab-pane fade show active">
          <div className="text-center py-5">
            <h5 className="text-muted"><FormattedMessage id="label.no_data_found" defaultMessage="No data found." /></h5>
          </div>
        </div>
      );
    }

    return (
      <div className="tab-pane fade show active">
        <div className="row gy-4 mt-0">
          <div className="col-lg-12">
            <div>
              <h3 className="heading-04 fw-bold text-dark mb-1">
                <FormattedMessage id="company_card.tech.title" defaultMessage="Technology Infrastructure" />
              </h3>
              <p className="text-grey-93 mb-0">
                <FormattedMessage id="company_card.tech.subtitle" defaultMessage="Comprehensive stack mapping as extracted from internal data." />
              </p>
            </div>
          </div>
        </div>

        <div className="row gy-4 mt-4">
          {(techStack || []).map((categoryData, idx) => (
            <div key={idx} className="col-lg-4 col-md-6 d-flex">
              <div className="card rounded-4 border border-grey-e6 shadow-none w-100">
                <div className="card-body p-4">
                  <span className="badge bg-black text-uppercase text-wrap text-start">
                    {_get(categoryData, "category", "")}
                  </span>
                  <div className="d-flex flex-wrap gap-2 mt-3">
                    {(!_get(categoryData, "technologies", []) || _get(categoryData, "technologies", []).length === 0) ? (
                      <span className="text-muted">
                        <FormattedMessage id="label.no_technology_found" defaultMessage="No technology found" />
                      </span>
                    ) : (
                      _get(categoryData, "technologies", []).map((technology, i) => (
                        <span key={i} className="bg-grey-fa text-dark heading-05 border fw-semibold px-3 py-2 rounded-3">
                          {(technology || "")}
                        </span>
                      ))
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default TechStack;
